export const InformPath = {
  welcome: "/welcome",
  verificationPending: "/verification-pending",
} as const;
